import { PuxButton, PuxTypography } from "@phonero/pux-react"
import vippsLogo from "../assets/svgs/icon/VippsLogo.svg"

//TODO: Endre parameter typen "paidBy" til å ta inn API enum (betales av jobb eller privat)
export const SimPaidByStatusMessage = ({ paidBy }: { paidBy: string }) => {
  return (
    <PuxButton
      style={{ maxWidth: "fit-content", maxHeight: "30px" }}
      shape="round"
      color="light"
      disabled
    >
      <PuxTypography style={{ color: "#FF5B24" }} variant="body2">
        {paidBy}
      </PuxTypography>
      <img src={vippsLogo} alt="Vipps logo" width="60" height="30" />
    </PuxButton>
  )
}